export default __webpack_public_path__ + "static/media/groups.6d86b430.svg";